import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "AccountEdit" })
export default class AccountEdit extends Vue {
    public localizer: any = Localizer;
    public formHelper: any = FormHelper;
    public isLoading: boolean = false;
    public isSuccess: boolean = false;
    public options: any = null;
    public editData: any = null;
    public formData: any = {};
    public registerData: any = {};
    public validationErrors: any[] = [];
    public isDeleteRequest: boolean = false;
    public deleteData: any = {};
    public validationDeleteErrors: any[] = [];

    @Prop() readonly returnUrl: string;

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        await Promise.all([this.getOptions(), this.getData()]);
    }

    public async getOptions() {
        this.options = (await Axios.post(this.routes.MyBeghelliProfile_GetOptions, null)).data;
    }

    public async getData() {
        this.editData = (await Axios.post(this.routes.MyBeghelliProfile_GetAccountEditData, null)).data;

        this.formData.userName = this.editData.userName;
        this.formData.email = this.editData.email;
    }

    public async submitForm() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoading = true;

        try {
            let result = (await Axios.post(this.routes.MyBeghelliProfile_AccountEdit, this.formData)).data;

            this.isSuccess = true;

            this.$store.dispatch("appToastStore/onAddToast", { message: this.localizer.get("App.Common.SuccessfullyUpdatedData"), type: "Success" });
        } catch (error) {
            if (error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoading = false;
    }

    public async confirmationRequest() {
        FormHelper.removeFocus();
        this.validationDeleteErrors = [];
        this.isLoading = true;

        try {
            const result = (await Axios.post(this.routes.MyBeghelliProfile_DeleteAccountRequest, this.deleteData)).data;

            if (result.redirectUrl) {
                window.location.href = result.redirectUrl;
            }
            else {
                window.location.href = this.routes.Home;
            }
        } catch (error) {
            if (error.response.status === 400) {
                this.validationDeleteErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoading = false;
    }

    public async removeExternal(loginProvider: string, providerKey: string) {
        let result = (await Axios.post(this.routes.Account_External_ExternalRemove, { loginProvider: loginProvider, providerKey: providerKey }, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;

        location.reload();
    }

    public goBack() {
        this.returnUrl ? window.location.href = this.returnUrl : history.back();
    }
};